import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b027dad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-select-create" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "txt-danger txt-required"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "c-option" }
const _hoisted_7 = { class: "select-valued" }
const _hoisted_8 = { class: "mr5" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "font15"
}
const _hoisted_11 = {
  class: "c-select-dropdown-item",
  style: {"padding-bottom":"0px"}
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  class: /*#__PURE__*/_normalizeClass('txt-info bold font15 cursor')
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = {
  key: 1,
  class: "mb0 txt-danger font14 mt3"
}

export function render(_ctx, _cache) {
  const _component_c_icon = _resolveComponent("c-icon")
  const _component_c_button = _resolveComponent("c-button")
  const _directive_outside = _resolveDirective("outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.updatedLabel,
          class: "txt-ellipsis bold"
        }, [
          _createTextVNode(_toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.onSelect && _ctx.onSelect(...args))),
      onKeydown: [
        _cache[10] || (_cache[10] = (...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
        _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
      ],
      tabindex: "0",
      class: _normalizeClass([{'active' : _ctx.isDropdown, 'outline-danger': _ctx.isError, 'select-box-disabled' : _ctx.readonly, 'c-select-created' : _ctx.selectedValue.length}, "row c-select"])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.selectedValue.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedValue, (option) => {
                return (_openBlock(), _createElementBlock("span", {
                  style: _normalizeStyle(!_ctx.isIcon && 'padding-left: 7px;'),
                  class: "mr5 selected-value"
                }, [
                  _createElementVNode("span", {
                    onClick: [
                      _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      _cache[2] || (_cache[2] = $event => (_ctx.isDropdown = false))
                    ],
                    onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_ctx.isIcon)
                      ? (_openBlock(), _createBlock(_component_c_icon, {
                          key: 0,
                          value: option.src,
                          "onUpdate:value": $event => ((option.src) = $event),
                          isDelete: true,
                          readonly: _ctx.readonly,
                          isArray: _ctx.isArray
                        }, null, 8, ["value", "onUpdate:value", "readonly", "isArray"]))
                      : _createCommentVNode("", true)
                  ], 32),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(option.value), 1),
                  (!_ctx.readonly)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _withModifiers($event => (_ctx.deleteOptionValue(option)), ["stop"])
                      }, " ✕ ", 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 4))
              }), 256))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('componentSelect')) + " " + _toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)), 1))
        ]),
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.isDropdown ? 'icon-element-up':'icon-element-down', {'mr0' : _ctx.readonly && _ctx.selectedValue.length}, "fa-angle-down fa bold ic-arrow-down"])
        }, null, 2)
      ]),
      (_ctx.isDropdown)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([[_ctx.isTop ? 'bottom-dropdown' : 'top-dropdown'], "c-select-dropdown c-select-dropdown-active"]),
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.searchable)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    onKeyup: _cache[3] || (_cache[3] = _withKeys((...args) => (_ctx.onCreateKeySearch && _ctx.onCreateKeySearch(...args)), ["enter"])),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.keySearch) = $event)),
                    ref: "keySearchQuery",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                    placeholder: _ctx.$t('componentSearch'),
                    type: "text",
                    class: "input mb10"
                  }, null, 40, _hoisted_12)), [
                    [_vModelText, _ctx.keySearch]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                class: "row flex-footer mt10 mb15"
              }, [
                _createElementVNode("label", _hoisted_13, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.isCreateSelect,
                    onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.toggleCreateSelect && _ctx.toggleCreateSelect(...args))),
                    class: "input-checkbox"
                  }, null, 40, _hoisted_14),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("componentCreateMore")), 1)
                ]),
                _createVNode(_component_c_button, {
                  onHandler: _ctx.onCreateKeySearch,
                  isDisabled: !_ctx.keySearch,
                  class: "btn btn-primary w100 ml10",
                  value: "componentSave",
                  type: "span"
                }, null, 8, ["onHandler", "isDisabled"])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 34)), [
      [_directive_outside, _ctx.outsideClick]
    ]),
    (_ctx.isError && _ctx.showError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isError)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}